import React, { useEffect } from 'react';
import { Form, Input, InputNumber, Row, Col, Card, Button, message } from 'antd';
import { PayrollProcessServices } from '@gtpl/shared-services/hrms';

export const EmployeePayrollCompForm = ({ record, getEmployeePayrollCompData }) => {
    const [form] = Form.useForm();
    const service = new PayrollProcessServices();
    const employeeType = record?.employeeType;


    useEffect(() => {
        if (record) {
            form.setFieldsValue(record);
        } else {
            form.resetFields();
        }
    }, [record, form]);

    const handleSave = (values) => {
        console.log(values);
        service.saveEmployeePayrollComponent(values).then((res) => {
            if (res.status) {
                message.success('saved successfullly')
            }
            getEmployeePayrollCompData();
        }).catch((err) => {
            console.log(err.message)
        })
    };

    return (
        <>
            <Card>
                <Form form={form} layout="vertical" onFinish={handleSave}>
                    {employeeType === 'Salaried Form' && (
                        <>
                            <Card title={<span style={{ color: 'black' }}>Allowances</span>}>
                                <Row gutter={16}>



                                    <Form.Item
                                        name="employeeId"
                                        hidden
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Col span={8}>
                                        <Form.Item
                                            name="employeeName"
                                            label="Employee Name"
                                        >
                                            <Input disabled />

                                        </Form.Item>
                                    </Col>

                                    <Col span={8}>
                                        <Form.Item
                                            name="basic"
                                            label="Basic"
                                        >
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item
                                            name="hraAmount"
                                            label="Hra Amount"
                                        >
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>

                                    <Col span={8}>
                                        <Form.Item
                                            name="eduAmount"
                                            label="EDU Amount"
                                        >
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>

                                    <Col span={8}>
                                        <Form.Item
                                            name="medicalAmount"
                                            label="Medical Amount"
                                        >
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>

                                    <Col span={8}>
                                        <Form.Item
                                            name="splAmount"
                                            label="Spl Amount"
                                        >
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>

                                    <Col span={8}>
                                        <Form.Item
                                            name="conveyanceAmount"
                                            label="Conveyance Amount"

                                        >
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>

                                    <Col span={8}>
                                        <Form.Item
                                            name="petrolAmount"
                                            label="Petrol Amount"
                                        >
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>

                                    <Col span={8}>
                                        <Form.Item
                                            name="shoeAmount"
                                            label="Shoe Amount"
                                        >
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>

                                    <Col span={8}>
                                        <Form.Item
                                            name="washingAmount"
                                            label="Washing Amount"
                                        >
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>

                                    <Col span={8}>
                                        <Form.Item
                                            name="uniformAmount"
                                            label="Uniform Amount"
                                        >
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item
                                            name="helperAmount"
                                            label="Helper Amount"
                                        >
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>

                                </Row>
                            </Card>
                            {/* <Card title={<span style={{ color: 'black' }}>Deductions</span>}>
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <Form.Item
                                            name="messAmount"
                                            label="Mess Amount"
                                        >
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item
                                            name="othersAmount"
                                            label="Others Amount"
                                        >
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>

                                </Row>
                            </Card> */}
                        </>
                    )}

                    {employeeType === 'Labour Form' && (
                        <>
                            <Card title={<span style={{ color: 'black' }}>Allowances</span>}>
                                <Row gutter={16}>


                                    <Form.Item
                                        name="employeeId"
                                        hidden
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Col span={8}>
                                        <Form.Item
                                            name="employeeName"
                                            label="Employee Name"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>

                                    <Col span={8}>
                                        <Form.Item
                                            name="basic"
                                            label="Basic"
                                        >
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item
                                            name="uniformAmount"
                                            label="Uniform Amount"
                                        >
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item
                                            name="splAmount"
                                            label="Spl Amount"
                                        >
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item
                                            name="washingAmount"
                                            label="Washing Amount"
                                        >
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col><Col span={8}>
                                        <Form.Item
                                            name="shoeAmount"
                                            label="Shoe Amount"
                                        >
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item
                                            name="medicalAmount"
                                            label="Medical & TA"
                                        >
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    
                                    <Col span={8}>
                                        <Form.Item
                                            name="productionAmount"
                                            label="Production Amount"
                                        >
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item
                                            name="taAmount"
                                            label="TA Amount"
                                        >
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item
                                            name="bonusAmount"
                                            label="Bonus Amount"
                                        >
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card>
                            {/* <Card title={<span style={{ color: 'black' }}>Deductions</span>}>
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <Form.Item
                                            name="messAmount"
                                            label="Mess Amount"
                                        >
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item
                                            name="othersAmount"
                                            label="Others Amount"
                                        >
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card> */}

                        </>
                    )}


                    <br />
                    <div style={{ float: 'right' }}>
                        <Button type='primary' htmlType='submit'>Save</Button>
                    </div>
                </Form>
            </Card>
        </>
    );
};

export default EmployeePayrollCompForm;
